export const CART_SLIDE_OVER = 'cart'
export const CARTS_SLIDE_OVER = 'carts'

export default { CART_SLIDE_OVER, CARTS_SLIDE_OVER }
